import { isNullOrUndefined } from "util";
import { UtilFunc } from "./UtilFunc";

export enum TextAlign {
	Left = "left",
	Center = "center",
	Right = "right"
};

export enum TextBaseline {
	Top = "top",
	Middle = "middle",
	Bottom = "bottom"
};

export enum TextColor {
	Default = '#89816d',
	Friend = '#7ead58',
	Info = '#c05158',
	Hover = 'ed7797'
}

export class CustomText extends createjs.Text {
	fontSize: number;
	virticalAlign: string;
	maxWidth: number;
	bBold: boolean;
	bMulutiline: boolean; //複数行
	protected _lineCount: number;
	static FIREFOX_BASELINE_GAP: number = -2;
	constructor(text: string = '', fontSize: number = 12, color: string = '#000', textAlign: string = 'left', textBaseline: string = 'top', bBold: boolean = false, bMultiline:boolean = false, maxWidth?:number, lineHeight?:number) {
		super();
		this.setFont(fontSize, bBold);
		this.color = color;
		this.textAlign = textAlign
		this.lineHeight = lineHeight || fontSize + 4;
		this.textBaseline = textBaseline; //ここはブラウザによって調整の必要あり
		this.bMulutiline = bMultiline;
		this.maxWidth = maxWidth;
		if (UtilFunc.getBrowserName() === UtilFunc.BrowserName.FireFox) {
			this.regY = + CustomText.FIREFOX_BASELINE_GAP;
		}
		this.setText(text);
	}

	clone(): CustomText{
		const o = new CustomText(this.text, this.fontSize, this.color, this.textAlign, this.textBaseline, this.bBold, this.bMulutiline, this.maxWidth, this.lineHeight);
		UtilFunc.clonePropsDisplayObject(this, o);
		return o;
	}


	/**
	 * 文字幅の最大を設定する （マルチラインなら折返し幅）
	 */
	setMaxWidth(width: number) {
		this.maxWidth = width;
		if (this.bMulutiline) {
			this.setText(this.text);
		}
	}

	setLineHeight(height: number) {
		this.lineHeight = height
	}

	getLineHeight():number {
		return this.text.split(/\n|\r\n/).length * this.lineHeight;
	}

	setText(text?: string) {
		if (UtilFunc.isValidString(text)) {
			//マルチラインかつ最大幅指定アリなら折返す
			if (this.maxWidth && this.bMulutiline) {
				let width: number = 0;
				let tempStr: string = '';
				let str: string = '';
				let lineCount = 1;
				let tempText = new createjs.Text("", this.generateFontString(), this.color);
				for (let i = 0; i < text.length; i++) {
					tempStr += text[i];
					tempText.text = tempStr;
					if (tempText.getBounds().width > this.maxWidth) {
						++lineCount;
						str += '\r\n' + text[i];
						tempStr = text[i]
					} else {
						str += text[i];
					}
				}
				this._lineCount = lineCount;
				this.text = str;
			} else {
				this._lineCount = 1
				this.text = text;
			}
		} else {
			this._lineCount = 0
			this.text = "";
		}
	}

	get lineCount(): number {
		return this._lineCount
	}

	/**
	 * 太字設定
	 *
	 * @param bBold 太字設定
	 */
	setBold(bBold: boolean) {
		this.bBold = bBold;
		this.setFont(this.fontSize, this.bBold);
	}

	/**
	 * Textクラス用フォント設定テキストの生成
	 *
	 * @param fontSize フォントサイズ
	 * @param bBold 太字設定
	 */
	private generateFontString(): string {
		const fontSetting: string = this.fontSize + "px 'Meiryo', 'メイリオ', 'Hiragino Kaku Gothic Pro', 'ヒラギノ角ゴ Pro W3',  'Osaka', 'MS PGothic', arial, helvetica, sans-serif";

		if (this.bBold) {
			return "bold " + fontSetting;
		} else {
			return fontSetting;
		}
	}

	/**
	 * フォントの設定
	 *
	 * @param fontSize フォントサイズ
	 * @param bBold 太字設定
	 */
	public setFont(fontSize: number, bBold: boolean): void {
		this.fontSize = fontSize;
		this.bBold = bBold;
		this.font = this.generateFontString();
	}

	/**
	 * テキストの当たり判定設定
	 */
	public setHitArea(): void {
		if (isNullOrUndefined(this.hitArea) == true) {
			this.hitArea = new createjs.Shape();
		}

		const bounds = this.getBounds();

		(<createjs.Shape>this.hitArea).graphics.beginFill(createjs.Graphics.getRGB(0, 0, 0)).drawRect(bounds.x, bounds.y, bounds.width, bounds.height).endFill();
	}

	changeColor(color: string) {
		this.color = color;
	}

	/**
	 * createjs.Textが縮小前の幅を出してくるので
	 */
	getMeasuredWidth(): number {
		const measuredWidth = super.getMeasuredWidth();
		if ( !!this.maxWidth ){
			return Math.min(this.maxWidth, measuredWidth);
		}
		return measuredWidth;
	}
}
